import script from "./app-footer.vue?vue&type=script&setup=true&lang=ts"
export * from "./app-footer.vue?vue&type=script&setup=true&lang=ts"

import "./app-footer.vue?vue&type=style&index=0&id=41fb2efe&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41fb2efe"]])

export default __exports__